// extracted by mini-css-extract-plugin
module.exports = {"loading-container":"loading-container--1Ckjl","big":"big--2eqbM","icon-loading":"icon-loading--1dAXB","small":"small--276qo"};